import Stack from '@mui/material/Stack';
import Btn from '@mui/material/Button';
import IconButton from "@mui/material/IconButton";
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteIcon from '@mui/icons-material/Delete';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import SaveIcon from '@mui/icons-material/Save';
import { Box } from '@mui/material';
import Typography from "@mui/material/Typography";

export const ButtonAdd = ({variant, onClick, type, width}) => {
    return (
        <>
        <Box
            sx={{
            "& > :not(style)": {m: 1,width: width ? width : "20ch"},
            }}
            >
            <Btn 
                startIcon={<PlaylistAddIcon />}
                variant="text"
                onClick={onClick}
                type={type}
                style={{background: '#2f9ded', borderRadius: '6px', color: 'white', textTransform: 'unset'}}
                >                
                 <label style={{cursor: 'pointer'}}>เพิ่ม F9</label>
            </Btn>
        </Box>
        </>
    );
};

export const ButtonSave = ({variant, onClick, type}) => {
    return (
        <>
            <Stack spacing={1}>
                <Btn 
                    startIcon={<SaveIcon />}
                    variant="text"
                    onClick={onClick}
                    type={type}
                    style={{background: '#0099FF', borderRadius: '6px', color: 'white'}}                
                    >                
                    บันทึก
                </Btn>
            </Stack>
        </>
    );
};

export const ButtonClose = ({variant, onClick, type}) => {
    return (
        <>
            <Stack spacing={1} >
                <Btn 
                    startIcon={<RemoveCircleOutlineIcon />}
                    variant="text"
                    onClick={onClick}
                    type={type}
                    style={{background: '#BEBEBE', borderRadius: '6px', color: 'white'}}                
                    >                
                     <label style={{cursor: 'pointer'}}>ปิด</label>
                </Btn>
            </Stack>
        </>
    );
};

export const ButtonEdit = ({onClick}) => {
    return (
        <>
            <IconButton onClick={onClick}>
                <ModeEditIcon size="small"/>
            </IconButton>
            {/* <Stack spacing={2} direction="row">
                <Btn 
                    variant={variant}
                    onClick={onClick}
                    type={type}                
                    >                
                แก้ไข
                </Btn>
            </Stack> */}
        </>
    );
};

export const ButtonDelete = ({onClick}) => {
    return (
        <>
            <IconButton onClick={onClick}>
                <DeleteIcon size="small"/>
            </IconButton>
            {/* <Stack spacing={2} direction="row">
                <Btn 
                    variant={variant}
                    onClick={onClick}
                    type={type}                
                    >                
                แก้ไข
                </Btn>
            </Stack> */}
        </>
    );
};

export const ButtonOther = ({onClick, message, startIcon, endIcon, variant, type, background, width, disabled}) => {
    return (
        <>
            <Box
                sx={{
                "& > :not(style)": {m: 1, width: width ? width : "10ch"},
                }}
                >
                <Btn 
                    startIcon={startIcon}
                    endIcon={endIcon}
                    variant={variant}
                    onClick={onClick}
                    type={type}
                    disabled={disabled}
                    style={{background: background ? background :'#1676FC', borderRadius: '6px', color: 'white', fontFamily: 'Sarabun'}}                
                    >                
                     {message}
                </Btn>
            </Box>
        </>
    );
};